module.exports = __webpack_public_path__ + "img/title.6392348e.png";